import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getRoot, getParent, types } from 'mobx-state-tree';
import { toJS } from 'mobx';
import AllocationsModel from './allocations';
import BillingTabModel from './billingTab';
import { PropertyDetailsModel } from './property';
import { PropertyUnitModel } from './property/resident';
import { UtilityInfoModel } from './property/billingTemplates';
import { CompanyFeatureSetModel } from './companyModels/companyFeatureSetModel';
import { CompanyTeamMemberModel } from './companyModels/companyTeamMemberModel';
import { PAYMENT_METHODS } from 'src/constants/payments';
import { isValueNumber } from 'src/utils/typeValidators';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { generateAddressString } from 'src/utils/address';
const UserAccessAllowedModel = types.model({
  accountId: types.string,
  firstName: types.optional(types.string, ''),
  lastName: types.optional(types.string, ''),
  email: types.maybeNull(types.string)
});

// TODO: Separate into own file
const PropertyDashboardItemModel = types.model({
  accessResponses: types.optional(types.array(UserAccessAllowedModel), []),
  propertyId: types.optional(types.string, ''),
  propertyIds: types.optional(types.array(types.string), []),
  propertyAddress: types.optional(types.string, ''),
  addressId: types.optional(types.string, ''),
  propertyStatus: types.optional(types.string, ''),
  enrollmentDate: types.optional(types.string, ''),
  unitsEnrolled: types.optional(types.number, 0),
  unitsTotal: types.optional(types.number, 0),
  totalUtilityCostToDate: types.optional(types.number, 0),
  utilityCostRecoveryToDate: types.optional(types.number, 0),
  utilityCostRecoveryPriorMonth: types.optional(types.number, 0),
  recoveryPercentage: types.optional(types.number, 0),
  previousMonth: types.optional(types.number, 0),
  accountsReceivable: types.optional(types.number, 0),
  distributionForCurrentMonth: types.optional(types.number, 0),
  currentMonth: types.optional(types.number, 0),
  nextMonth: types.optional(types.number, 0),
  distributionToDate: types.optional(types.number, 0),
  isDemo: types.optional(types.boolean, false),
  utilityCount: types.optional(types.number, 0),
  utilityIds: types.optional(types.array(types.string), []),
  convergentBillingModeOverride: types.maybeNull(types.boolean)
}).actions(store => {
  return {
    updateModel(payload) {
      Object.entries(payload).forEach(_ref => {
        let _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        store[key] = value;
      });
    }
  };
});

// TODO: TBD when time comes to Final bill tab
const PropertyFinalBillModel = types.model({
  id: types.string
});
const BuildingAddressDetailsModel = types.model('BuildingAddressDetailsModel', {
  addressId: types.string,
  city: types.string,
  isValid: types.boolean,
  secondary: types.optional(types.string, ''),
  state: types.string,
  street: types.string,
  zip: types.string
}).actions(store => {
  return {
    updateModel(payload) {
      Object.entries(payload).forEach(_ref3 => {
        let _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        store[key] = value;
      });
    }
  };
}).views(self => ({
  get addressString() {
    return generateAddressString(self);
  }
}));
const PropertyBuildingInfoModel = types.model('PropertyBuildingInfoModel', {
  id: types.string,
  buildingAddressId: types.string,
  buildingAddress: types.maybeNull(types.string),
  address: types.maybeNull(BuildingAddressDetailsModel)
}).actions(store => {
  return {
    updateModel(payload) {
      Object.entries(payload).forEach(_ref5 => {
        let _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];
        if (key === 'address') {
          if (store.address) {
            store.address.updateModel(value);
          } else {
            store.address = value;
          }
        } else {
          store[key] = value;
        }
      });
    }
  };
});
const PropertyContactModel = types.model('PropertyContactModel', {
  contactType: types.string,
  // Building | Utility
  teamMemberId: types.string
});
const PropertyGeneralInfo = types.model('PropertyGeneralInfo', {
  type: types.string,
  propertyContacts: types.optional(types.array(PropertyContactModel), []),
  accessResponses: types.optional(types.array(UserAccessAllowedModel), []),
  portfolioIds: types.optional(types.array(types.string), []),
  accountAccess: types.maybeNull(types.model('AccountAccess', {
    accountIds: types.optional(types.array(types.string), [])
  })),
  id: types.string,
  propertyAddress: types.maybeNull(types.string),
  addressId: types.string,
  address: types.maybeNull(BuildingAddressDetailsModel),
  portfolioId: types.maybeNull(types.string),
  ownership: types.maybeNull(types.string),
  totalUnitsSquareFootage: types.maybeNull(types.number),
  buildings: types.optional(types.array(types.model({
    id: types.string,
    buildingAddress: types.maybeNull(types.string),
    buildingAddressId: types.string,
    buildingSquare: types.maybeNull(types.number)
  })), [])
}).actions(store => {
  return {
    updateModel(payload) {
      store.type = payload.id;
      store.propertyContacts = payload.propertyContacts;
      if (store.address) {
        store.address.updateModel(payload.address);
      } else {
        store.address = payload.buildingAddressId;
      }
      store.accessResponses = payload.accessResponses;
      store.id = payload.id;
      store.propertyAddress = payload.propertyAddress;
      store.addressId = payload.addressId;
      store.portfolioId = payload.portfolioId;
      store.portfolioIds = payload.portfolioIds;
      store.ownership = payload.ownership;
      store.totalUnitsSquareFootage = payload.totalUnitsSquareFootage;
      if (store.buildings) {
        Object.keys(toJS(store.buildings)).forEach(key => {
          store.buildings[key] = payload.buildings[key];
        });
      } else store.buildings = payload.buildings;
    }
  };
});
const PropertyModel = types.model('PropertyModel', {
  allocations: types.optional(AllocationsModel, {}),
  id: types.string,
  buildingInformation: types.maybeNull(PropertyBuildingInfoModel),
  propertyInformation: types.maybeNull(PropertyGeneralInfo),
  accessResponses: types.optional(types.array(UserAccessAllowedModel), []),
  dashboard: types.maybeNull(PropertyDashboardItemModel),
  details: types.maybeNull(types.optional(PropertyDetailsModel, {})),
  residents: types.optional(types.array(PropertyUnitModel), []),
  finalBills: types.optional(types.array(PropertyFinalBillModel), []) // TODO: TBD when time comes to Final bill tab
}).actions(store => {
  return {
    updateAccessResponses(payload) {
      store.accessResponses = payload;
    },
    updateDashboard(payload) {
      store.dashboard.updateModel(payload);
    },
    setPropertyBuildingSquare(value) {
      if (isValueNumber(value)) store.propertyInformation.buildings[0].buildingSquare = Number(value);
    },
    setUpdateContacts(payload) {
      store.propertyInformation.propertyContacts = payload;
    },
    fetchContacts() {
      return getRoot(store).properties.getPropertysContactsAsync.run({
        propertyId: store.id
      }, [store.id]).then(contactsRes => {
        if (contactsRes !== null && contactsRes !== void 0 && contactsRes.isSuccessful) {
          store.setUpdateContacts(contactsRes.response);
        }
      });
    }
  };
}).views(store => ({
  get propertyBuildingSquare() {
    var _store$propertyInform;
    return ((_store$propertyInform = store.propertyInformation) === null || _store$propertyInform === void 0 || (_store$propertyInform = _store$propertyInform.buildings[0]) === null || _store$propertyInform === void 0 ? void 0 : _store$propertyInform.buildingSquare) || null;
  },
  get propertyBuildingId() {
    var _store$propertyInform2;
    return ((_store$propertyInform2 = store.propertyInformation) === null || _store$propertyInform2 === void 0 || (_store$propertyInform2 = _store$propertyInform2.buildings[0]) === null || _store$propertyInform2 === void 0 ? void 0 : _store$propertyInform2.id) || null;
  },
  get propertyAddressSeparated() {
    var _store$propertyInform3;
    return (_store$propertyInform3 = store.propertyInformation) === null || _store$propertyInform3 === void 0 ? void 0 : _store$propertyInform3.address;
  },
  get propertyPortfolioInfo() {
    return getParent(getParent(store));
  },
  get propertyStatus() {
    var _store$dashboard;
    return (_store$dashboard = store.dashboard) === null || _store$dashboard === void 0 ? void 0 : _store$dashboard.propertyStatus;
  },
  get propertyAddress() {
    var _store$propertyInform4, _store$dashboard2;
    return ((_store$propertyInform4 = store.propertyInformation) === null || _store$propertyInform4 === void 0 || (_store$propertyInform4 = _store$propertyInform4.address) === null || _store$propertyInform4 === void 0 ? void 0 : _store$propertyInform4.addressString) || ((_store$dashboard2 = store.dashboard) === null || _store$dashboard2 === void 0 ? void 0 : _store$dashboard2.propertyAddress) || 'N/a';
  }
}));
const PortfolioModel = types.model('PortfolioModel', {
  id: types.string,
  name: types.string,
  properties: types.optional(types.array(PropertyModel), []),
  accessResponses: types.optional(types.array(UserAccessAllowedModel), []),
  isDefault: types.optional(types.boolean, false),
  navExpanded: types.optional(types.boolean, true)
}).actions(store => {
  return {
    setNavExpanded(value) {
      store.navExpanded = value;
    },
    setUpdatePortfolio(payload) {
      if (store.id === payload.id) {
        store.name = payload.name;
        store.accessResponses = payload.accessResponses;
        payload.properties.forEach(payloadProperty => {
          const propertyToUpdate = store.properties.find(storeProperty => storeProperty.id === payloadProperty.id);
          if (!propertyToUpdate) {
            store.properties.push(payloadProperty);
            return;
          }
          if (!!payloadProperty.dashboard) propertyToUpdate.updateDashboard(payloadProperty.dashboard);
          if (!!payloadProperty.accessResponses) propertyToUpdate.updateAccessResponses(payloadProperty.accessResponses);
        });
        const payloadPropertiesIds = payload.properties.map(property => property.id);
        const propertiesToRemove = store.properties.filter(p => !payloadPropertiesIds.includes(p.id));
        propertiesToRemove.forEach(property => {
          const index = store.properties.findIndex(p => p.id === property.id);
          if (index !== -1) {
            if (getRoot(store).homeDashboardStore.selectedPropertyId === store.properties[index].id) {
              getRoot(store).homeDashboardStore.selectActivePropertyId('portfolio_details', true);
            }
            store.properties.splice(index, 1);
          }
        });
      }
    },
    setFilteredProperties(payload) {
      store.properties = payload;
    },
    deleteProperty(id) {
      const idx = store.properties.findIndex(i => i.id === id);
      if (getRoot(store).homeDashboardStore.selectedPropertyId === id) {
        getRoot(store).homeDashboardStore.selectActivePortfolioId('all');
        getRoot(store).homeDashboardStore.selectActivePropertyId('all');
      }
      store.properties.splice(idx, 1);
    }
  };
});
const ReimbursementMethodModel = types // NOTE: for payout methods
.model('ReimbursementMethodModel', {
  id: types.string,
  propertyIds: types.array(types.string),
  // NOTE: leftover from old implementation, tbd remove
  // propertyId: types.string,
  // isPrimary: types.boolean,
  // Regular Check type
  payeeName: types.maybeNull(types.string),
  payeeAddress: types.maybeNull(types.string),
  // ACH Direct deposit type
  nameOnAccount: types.maybeNull(types.string),
  depositoryName: types.maybeNull(types.string),
  routingNumber: types.maybeNull(types.string),
  accountNumber: types.maybeNull(types.string)
}).actions(store => {
  return {
    updateModel(data) {
      store.id = data.id;
      // store.propertyId = data.propertyId;
      store.propertyIds = data.propertyIds;
      // store.isPrimary = data.isPrimary;
      store.payeeName = data.payeeName;
      store.payeeAddress = data.payeeAddress;
      store.nameOnAccount = data.nameOnAccount;
      store.depositoryName = data.depositoryName;
      store.routingNumber = data.routingNumber;
      store.accountNumber = data.accountNumber;
    }
  };
}).views(store => ({
  get methodType() {
    if (store.payeeName !== null && store.payeeAddress !== null) return PAYMENT_METHODS.RegularCheck;
    if (store.nameOnAccount !== null && store.depositoryName !== null && store.routingNumber !== null && store.accountNumber !== null) return PAYMENT_METHODS.ACH;
  }
}));
const NavigationFilterOptions = types.model('NavigationFilterOptions', {
  sortOrder: types.optional(types.string, 'asc'),
  // asc | desc
  selectedItemsToShow: types.optional(types.array(types.string), []),
  // Statuses shown in the portfolio nav tree, empty = all. Visual only: consumed by SmartNav,
  // not by filteredItems, so it never changes which properties the dashboard loads or selects.
  statusFilter: types.optional(types.array(types.string), []),
  filterBy: types.optional(types.string, 'all') // 'all' | 'pending-utilities' | 'applied-utilities' - TODO: not implemented yet, it's placeholder
}).actions(store => {
  return {
    resetFilterOptions() {
      store.sortOrder = 'asc';
      store.selectedItemsToShow = [];
      store.statusFilter = [];
      store.filterBy = 'all';
    },
    setSortOrder(order) {
      store.sortOrder = order;
    },
    toggleItemSelection(id) {
      const selectedItemIndex = store.selectedItemsToShow.findIndex(i => i === id);
      if (selectedItemIndex !== -1) {
        store.selectedItemsToShow.splice(selectedItemIndex, 1);
      } else {
        store.selectedItemsToShow.push(id);
      }
    },
    setStatusFilter(statuses) {
      store.statusFilter = statuses;
    },
    setFilterBy(filterBy) {
      store.filterBy = filterBy;
    }
  };
}).views(self => ({
  isItemSelected(id) {
    return self.selectedItemsToShow.includes(id);
  },
  get selectedSortOrder() {
    return self.sortOrder;
  },
  get isFilterDefault() {
    return self.sortOrder === 'asc' && self.selectedItemsToShow.length === 0 && self.statusFilter.length === 0 && self.filterBy === 'all' || false;
  }
}));
const PortfolioNavOptions = NavigationFilterOptions.named('PortfolioNavOptions').views(self => ({
  get filteredItems() {
    return getParent(self).portfolios.slice().sort((pA, pB) => {
      switch (self.sortOrder) {
        case 'asc':
          return pA.name.localeCompare(pB.name);
        case 'desc':
          return pB.name.localeCompare(pA.name);
        default:
          return 0;
      }
    }).map(portfolio => {
      portfolio.setFilteredProperties(portfolio.properties.slice().sort((pA, pB) => {
        switch (self.sortOrder) {
          case 'asc':
            return pA.dashboard.propertyAddress.localeCompare(pB.dashboard.propertyAddress);
          case 'desc':
            return pB.dashboard.propertyAddress.localeCompare(pA.dashboard.propertyAddress);
          default:
            return 0;
        }
      }));
      return portfolio;
    }).filter(portfolio => {
      if (self.selectedItemsToShow.length) {
        return self.selectedItemsToShow.includes(portfolio.id);
      } else {
        return true;
      }
    });
  }
}));
const PropertiesNavOptions = NavigationFilterOptions.named('PropertiesNavOptions').views(self => ({
  get sortedItems() {
    return getParent(self).portfolioNavOptions.filteredItems.filter(portfolio => getRoot(self).homeDashboardStore.selectedPortfolioId !== 'all' ? getRoot(self).homeDashboardStore.selectedPortfolioId === portfolio.id : true).map(i => i.properties).flat().slice().sort((pA, pB) => {
      switch (self.sortOrder) {
        case 'asc':
          return pA.dashboard.propertyAddress.localeCompare(pB.dashboard.propertyAddress);
        case 'desc':
          return pB.dashboard.propertyAddress.localeCompare(pA.dashboard.propertyAddress);
        default:
          return 0;
      }
    });
  },
  get filteredItems() {
    return self.sortedItems.filter(property => {
      if (self.selectedItemsToShow.length) {
        return self.selectedItemsToShow.includes(property.id);
      } else {
        return true;
      }
    });
  }
}));
const CommonAreaAmenityOptionModel = types.model('commonAreaAmenityOptionModel', {
  id: types.string,
  name: types.string,
  weight: types.number
}).actions(store => {
  return {
    updateModel(payload) {
      Object.entries(payload).forEach(_ref7 => {
        let _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];
        store[key] = value;
      });
    }
  };
});
const CommonAreaAmenityModel = types.model('CommonAreaAmenityModel', {
  id: types.string,
  name: types.string,
  commonAreaAmenityOptions: types.array(CommonAreaAmenityOptionModel)
}).actions(store => {
  return {
    updateModel(payload) {
      Object.entries(payload).forEach(_ref9 => {
        let _ref0 = _slicedToArray(_ref9, 2),
          key = _ref0[0],
          value = _ref0[1];
        store[key] = value;
      });
    }
  };
});
const CompanyData = types.model('CompanyData', {
  billingTab: types.optional(BillingTabModel, {}),
  id: types.string,
  name: types.maybeNull(types.string),
  portfolios: types.optional(types.array(PortfolioModel), []),
  companyFeatureSet: types.optional(CompanyFeatureSetModel, {}),
  paymentMethods: types.optional(types.array(types.string), []),
  reimbursementMethods: types.optional(types.array(ReimbursementMethodModel), []),
  teamMembers: types.optional(types.array(CompanyTeamMemberModel), []),
  utilitiesInfo: types.optional(types.array(UtilityInfoModel), []),
  companyDashboardViewType: types.optional(types.string, 'navigation-view'),
  // | 'list-view'
  portfolioNavOptions: types.optional(PortfolioNavOptions, {
    sortOrder: 'asc',
    selectedItemsToShow: [],
    filterBy: 'all'
  }),
  propertyNavOptions: types.optional(PropertiesNavOptions, {
    sortOrder: 'asc',
    selectedItemsToShow: [],
    filterBy: 'all'
  }),
  commonAreaAmenities: types.optional(types.array(CommonAreaAmenityModel), []),
  companyResidentsTabOptions: types.optional(types.model('CompanyResidentsTabOptionsModel', {
    residenciesCount: types.maybeNull(types.number),
    unitsCount: types.maybeNull(types.number),
    refreshResidentsFlag: types.optional(types.boolean, false),
    includeEmptyUnitsFlag: types.optional(types.boolean, false)
  }).actions(store => {
    return {
      updateModel(payload) {
        try {
          var _getRoot$homeDashboar;
          if ((_getRoot$homeDashboar = getRoot(store).homeDashboardStore.currentAbortController) !== null && _getRoot$homeDashboar !== void 0 && _getRoot$homeDashboar.signal.aborted) return;
          Object.entries(payload).forEach(_ref1 => {
            let _ref10 = _slicedToArray(_ref1, 2),
              key = _ref10[0],
              value = _ref10[1];
            store[key] = value;
          });
        } catch (e) {
          console.error('companyResidentsTabOptions', e);
        }
      }
    };
  }), {}),
  companyPropertiesNavOpen: types.optional(types.boolean, true),
  // Opened by default
  daysTillStatementDate: types.optional(types.maybeNull(types.number), null),
  currentAllocationCycleId: types.optional(types.maybeNull(types.string), null),
  companyPortfoliosData: types.optional(types.array(types.model('CompanyPortfoliosDataModel', {
    id: types.string,
    name: types.string,
    isDefault: types.optional(types.boolean, false)
  })), [])
}).actions(store => {
  return {
    setDaysTillStatementDate(data) {
      store.daysTillStatementDate = data;
    },
    setCurrentAllocationCycleId(data) {
      store.currentAllocationCycleId = data;
    },
    setCompanyName(name) {
      store.name = name;
    },
    changeCompanyDashboardViewType: viewType => {
      store.companyDashboardViewType = viewType;
    },
    changeCompanyPropertiesNavOpenState: state => {
      if (state === undefined) {
        state = !store.companyPropertiesNavOpen;
      }
      store.companyPropertiesNavOpen = state;
    },
    setUpdateCompanyPortfoliosData(payload) {
      if (store.id === payload.id) {
        var _store$portfolios;
        if (!((_store$portfolios = store.portfolios) !== null && _store$portfolios !== void 0 && _store$portfolios.length)) {
          store.portfolios = payload.portfolios;
          return;
        }
        const portfolioIdsToUpdate = new Set(payload.portfolios.map(portfolio => portfolio === null || portfolio === void 0 ? void 0 : portfolio.id));
        const portfolioIndexMap = new Map(store.portfolios.map((portfolio, index) => [portfolio.id, index]));
        payload.portfolios.forEach(payloadPortfolio => {
          const existingPortfolioIndex = portfolioIndexMap.get(payloadPortfolio.id);
          if (existingPortfolioIndex !== undefined) {
            store.portfolios[existingPortfolioIndex].setUpdatePortfolio(payloadPortfolio);
          } else {
            store.portfolios.push(payloadPortfolio);
          }
        });
        for (let i = store.portfolios.length - 1; i >= 0; i--) {
          var _store$portfolios$i;
          if (!portfolioIdsToUpdate.has((_store$portfolios$i = store.portfolios[i]) === null || _store$portfolios$i === void 0 ? void 0 : _store$portfolios$i.id)) {
            store.portfolios.splice(i, 1);
          }
        }
      }
    },
    setPropertyBuildingInfo(portfolioId, propertyId, payload) {
      const propertyPortfolios = store.portfolios.filter(portfolio => portfolio.properties.findIndex(property => property.id === propertyId) !== -1);
      propertyPortfolios.forEach(portfolio => {
        const propertyIndex = portfolio.properties.findIndex(property => property.id === propertyId);
        if (propertyIndex !== -1) {
          if (portfolio.properties[propertyIndex].buildingInformation === null) {
            portfolio.properties[propertyIndex].buildingInformation = payload;
          } else {
            portfolio.properties[propertyIndex].buildingInformation.updateModel(payload);
          }
        }
      });
    },
    fetchBuildingInformation(_ref11) {
      let propertyId = _ref11.propertyId,
        portfolioId = _ref11.portfolioId;
      return getRoot(store).buildings.getBuildingAsync.run({
        propertyId: propertyId
      }, [propertyId]).then(resp => {
        if (resp !== null && resp !== void 0 && resp.isSuccessful) store.setPropertyBuildingInfo(portfolioId, propertyId, singleElementOfArray(resp.response));
      });
    },
    fetchBuildingsInformationBatch(propertiesPayload) {
      var _getRoot$homeDashboar2;
      if ((_getRoot$homeDashboar2 = getRoot(store).homeDashboardStore.currentAbortController) !== null && _getRoot$homeDashboar2 !== void 0 && _getRoot$homeDashboar2.signal.aborted) return;
      return getRoot(store).buildings.getBuildingsBatchAsync.run({
        propertyIds: propertiesPayload.map(i => i.propertyId)
      }, propertiesPayload.map(i => i.propertyId)).then(resp => {
        if (resp !== null && resp !== void 0 && resp.isSuccessful) {
          resp === null || resp === void 0 || resp.response.forEach(item => {
            store.setPropertyBuildingInfo(item.portfolioId, item.id, item);
          });
        }
      });
    },
    setPropertyInformation(propertyId, payload) {
      const propertyPortfolios = store.portfolios.filter(portfolio => portfolio.properties.findIndex(property => property.id === propertyId) !== -1);
      propertyPortfolios.forEach(portfolio => {
        const propertyIndex = portfolio.properties.findIndex(property => property.id === propertyId);
        if (propertyIndex !== -1) {
          if (portfolio.properties[propertyIndex].propertyInformation === null) {
            portfolio.properties[propertyIndex].propertyInformation = payload;
          } else {
            portfolio.properties[propertyIndex].propertyInformation.updateModel(payload);
          }
          portfolio.properties[propertyIndex].fetchContacts();
        }
      });
    },
    fetchPropertyInformation(_ref12) {
      let propertyId = _ref12.propertyId;
      return getRoot(store).properties.getPropertyAsync.run({
        propertyId: propertyId
      }, [propertyId]).then(resp => {
        if (resp !== null && resp !== void 0 && resp.isSuccessful) store.setPropertyInformation(propertyId, resp === null || resp === void 0 ? void 0 : resp.response);
      });
    },
    fetchPropertyInformationBatch(propertiesPayload) {
      var _getRoot$homeDashboar3;
      if ((_getRoot$homeDashboar3 = getRoot(store).homeDashboardStore.currentAbortController) !== null && _getRoot$homeDashboar3 !== void 0 && _getRoot$homeDashboar3.signal.aborted) return;
      return getRoot(store).properties.getPropertiesBatchAsync.run({
        propertyIds: propertiesPayload.map(i => i.propertyId)
      }, propertiesPayload.map(i => i.propertyId)).then(resp => {
        if (resp !== null && resp !== void 0 && resp.isSuccessful) {
          resp === null || resp === void 0 || resp.response.forEach(item => {
            store.setPropertyInformation(item.id, item);
          });
        }
      });
    },
    setCommonAreaAmenities(_ref13) {
      let payload = _ref13.payload;
      payload.forEach(amenityPayload => {
        const existingAmenityIndex = store.commonAreaAmenities.findIndex(i => i.id === amenityPayload.id);
        if (existingAmenityIndex !== -1) {
          store.commonAreaAmenities[existingAmenityIndex].updateModel(amenityPayload);
        } else {
          store.commonAreaAmenities.push(amenityPayload);
        }
      });
    },
    fetchCommonAreaAmenities() {
      getRoot(store).amenities.getAllCommonAreaAmenitiesRawAsync.run(undefined, [store.id]).then(resp => {
        if (resp !== null && resp !== void 0 && resp.isSuccessful) store.setCommonAreaAmenities({
          payload: resp === null || resp === void 0 ? void 0 : resp.response
        });
      });
    },
    fetchPropertyPaymentMethod(_ref14) {
      let propertyId = _ref14.propertyId;
      getRoot(store).payment.getPropertyPaymentMethodAsync.run({
        applyToHomeDashboard: true,
        propertyId: propertyId
      });
    },
    fetchPropertyCommonAreaAmenities(_ref15) {
      let propertyId = _ref15.propertyId,
        portfolioId = _ref15.portfolioId;
      const matchingPortfolioId = portfolioId === 'all' ? store.propertyPortfolioDetails(propertyId).id : portfolioId;
      const portfolioIndex = store.portfolios.findIndex(portfolio => portfolio.id === matchingPortfolioId);
      if (portfolioIndex !== -1) {
        var _store$portfolios$por;
        const propertyIndex = (_store$portfolios$por = store.portfolios[portfolioIndex]) === null || _store$portfolios$por === void 0 ? void 0 : _store$portfolios$por.properties.findIndex(property => property.id === propertyId);
        if (propertyIndex !== -1) {
          store.portfolios[portfolioIndex].properties[propertyIndex].details.fetchAmenities();
        }
      }
    },
    // NOTE: utilitiesInfo actions
    setUtilitiesInfo(data) {
      const mergedUtilitiesMap = new Map([...store.utilitiesInfo.map(info => [info.utilityId, info]), ...data.map(datum => [datum.utilityId, datum])]);
      store.utilitiesInfo = Array.from(mergedUtilitiesMap.values());
    },
    setUtilitiesInfoForCustomProvider(data) {
      store.setUtilitiesInfo(data);
    },
    fetchUtilitiesInfo(utilityIds) {
      // if (getRoot(store).homeDashboardStore.propertyId) {
      return getRoot(store).utilityProviders.getUtilityInfoAsync.run({
        utilityIds: utilityIds
      }, utilityIds).then(response => {
        if (response !== null && response !== void 0 && response.isSuccessful) {
          store.setUtilitiesInfo(response.response.utilities);
        }
      });
      // }
    },
    fetchOldUtilitiesInfo(utilities) {
      // id is equal to propertyUtilityId
      if (getRoot(store).homeDashboardStore.propertyId) {
        getRoot(store).utilityProviders.getUtilityInfoAsync.run({
          utilityIds: utilities.map(ut => ut.utilityId)
        }, utilities.map(ut => ut.utilityId)).then(response => {
          if (response.isSuccessful) {
            store.setUtilitiesInfo(response.response.utilities.map(ut => {
              var _utilities$find;
              return _objectSpread(_objectSpread({}, ut), {}, {
                id: (_utilities$find = utilities.find(i => i.utilityId === ut.utilityId)) === null || _utilities$find === void 0 ? void 0 : _utilities$find.id
              });
            }));
          }
        });
      }
    },
    setCompanyACHs(payload) {
      payload.forEach(paymentMethodPayload => {
        const existingACHMethodIndex = store.reimbursementMethods.findIndex(i => i.id === paymentMethodPayload.id);
        if (existingACHMethodIndex !== -1) {
          store.reimbursementMethods[existingACHMethodIndex].updateModel(paymentMethodPayload);
        } else {
          store.reimbursementMethods.push(paymentMethodPayload);
        }
      });
    },
    fetchCompanyACHs() {
      let _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          customInProgressFetchId: undefined
        },
        customInProgressFetchId = _ref16.customInProgressFetchId;
      getRoot(store).payment.getCompanyAchDirectDepositsListAsync.run({}, [store.id, customInProgressFetchId].filter(i => !!i)).then(response => {
        if (response.isSuccessful) {
          store.setCompanyACHs(response.response);
        }
      });
    },
    setCompanyRegularChecks(payload) {
      payload.forEach(paymentMethodPayload => {
        const existingACHMethodIndex = store.reimbursementMethods.findIndex(i => i.id === paymentMethodPayload.id);
        if (existingACHMethodIndex !== -1) {
          store.reimbursementMethods[existingACHMethodIndex].updateModel(paymentMethodPayload);
        } else {
          store.reimbursementMethods.push(paymentMethodPayload);
        }
      });
    },
    fetchCompanyRegularChecks() {
      let _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          customInProgressFetchId: undefined
        },
        customInProgressFetchId = _ref17.customInProgressFetchId;
      getRoot(store).payment.getCompanyPayoutRegularChecksListAsync.run({}, [store.id, customInProgressFetchId].filter(i => !!i)).then(response => {
        if (response.isSuccessful) {
          store.setCompanyRegularChecks(response.response);
        }
      });
    },
    setCompanyPayoutMethods(payload) {
      payload.forEach(paymentMethodPayload => {
        const existingACHMethodIndex = store.reimbursementMethods.findIndex(i => i.id === paymentMethodPayload.id);
        if (existingACHMethodIndex !== -1) {
          store.reimbursementMethods[existingACHMethodIndex].updateModel(paymentMethodPayload);
        } else {
          store.reimbursementMethods.push(paymentMethodPayload);
        }
      });
    },
    fetchCompanyPayoutMethods() {
      let _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          customInProgressFetchId: undefined
        },
        customInProgressFetchId = _ref18.customInProgressFetchId;
      return getRoot(store).payment.getCompanyPayoutMethodsAsync.run({}, [store.id, customInProgressFetchId].filter(i => !!i)).then(response => {
        if (response !== null && response !== void 0 && response.isSuccessful) {
          store.setCompanyPayoutMethods(response.response);
        }
      });
    },
    setCompanyResidents(payload) {
      const unicUnitResidentIdentifier = unitItem => {
        var _unitItem$residencyId, _unitItem$accountId;
        return "".concat(unitItem.unitId, "-").concat((_unitItem$residencyId = unitItem === null || unitItem === void 0 ? void 0 : unitItem.residencyId) !== null && _unitItem$residencyId !== void 0 ? _unitItem$residencyId : null, "-").concat((_unitItem$accountId = unitItem === null || unitItem === void 0 ? void 0 : unitItem.accountId) !== null && _unitItem$accountId !== void 0 ? _unitItem$accountId : null);
      };
      const groupBy = (items, groupingKeys) => {
        const groupsMap = new Map();
        items.forEach(item => {
          const unicComboKey = groupingKeys.map(i => item[i]).join('-');
          if (!groupsMap.has(unicComboKey)) {
            groupsMap.set(unicComboKey, _objectSpread(_objectSpread({}, groupingKeys.reduce((acc, key) => {
              acc[key] = item[key];
              return acc;
            }, {})), {}, {
              items: []
            }));
          }
          groupsMap.get(unicComboKey).items.push(item);
        });
        return Array.from(groupsMap.values());
      };
      const groupedUnitsByProperty = groupBy(payload, ['propertyId', 'portfolioId']);
      groupedUnitsByProperty.forEach(groupByProperty => {
        const propertyItem = store.propertyDetails(groupByProperty.propertyId);
        const groupedByUnitId = groupBy(groupByProperty.items, ['unitId']);
        groupedByUnitId.forEach(_ref19 => {
          var _propertyItem$residen, _propertyItem$residen2;
          let unitId = _ref19.unitId,
            unitPayloadItems = _ref19.items;
          // NOTE: If store residents is empty or doesn't contain unitId, push all residents/units
          if (!((_propertyItem$residen = propertyItem.residents) !== null && _propertyItem$residen !== void 0 && _propertyItem$residen.length) || !((_propertyItem$residen2 = propertyItem.residents.filter(i => i.unitId === unitId)) !== null && _propertyItem$residen2 !== void 0 && _propertyItem$residen2.length)) {
            propertyItem.residents.push(...unitPayloadItems);
          } else {
            // NOTE: If store residents contains unitId, update existing residents and remove those that are not in payload
            const propertyUnitResidentsToRemove = [];
            propertyItem.residents.filter(i => i.unitId === unitId).forEach(propertyUnitResident => {
              const residentIndex = unitPayloadItems.findIndex(unitPayloadItem => unicUnitResidentIdentifier(unitPayloadItem) === unicUnitResidentIdentifier(propertyUnitResident));
              if (residentIndex !== -1) {
                propertyUnitResident.updateModel(unitPayloadItems[residentIndex]);
              } else {
                propertyUnitResidentsToRemove.push(unicUnitResidentIdentifier(propertyUnitResident));
              }
            });
            if (!!propertyUnitResidentsToRemove.length) {
              propertyUnitResidentsToRemove.forEach(unitIdToRemove => {
                const residentIndex = propertyItem.residents.findIndex(i => unicUnitResidentIdentifier(i) === unitIdToRemove);
                if (residentIndex !== -1) {
                  propertyItem.residents.splice(residentIndex, 1);
                }
              });
            }
            // NOTE: If store residents contains unitId, but not all residents, push those that are not in store
            unitPayloadItems.filter(i => i.unitId === unitId).filter(i => !propertyItem.residents.find(j => unicUnitResidentIdentifier(j) === unicUnitResidentIdentifier(i))).forEach(item => {
              propertyItem.residents.push(item);
            });
          }
        });
      });
    },
    setCompanyTeamMembers(payload) {
      payload.forEach(teamMemberPayload => {
        const existingTeamMemberIndex = store.teamMembers.findIndex(i => i.id === teamMemberPayload.id);
        if (existingTeamMemberIndex !== -1) {
          store.teamMembers[existingTeamMemberIndex].setUpdateModel(teamMemberPayload);
        } else {
          store.teamMembers.push(teamMemberPayload);
        }
      });
    },
    fetchCompanyTeamMembers() {
      let _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          customInProgressFetchId: undefined
        },
        customInProgressFetchId = _ref20.customInProgressFetchId;
      return getRoot(store).teamMembers.getCompanyTeamMembersAsync.run({
        companyId: store.id,
        returnCompleteDataObj: true
      }, [store.id, customInProgressFetchId].filter(i => !!i)).then(res => {
        if (res !== null && res !== void 0 && res.isSuccessful) store.setCompanyTeamMembers(res.response);
      });
    },
    fetchCompanyAppfolioGlCodes() {
      let _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          customInProgressFetchId: undefined,
          propertyId: undefined
        },
        customInProgressFetchId = _ref21.customInProgressFetchId,
        propertyId = _ref21.propertyId;
      if (propertyId !== undefined) {
        const existingCompanyProperty = store.propertyDetails(propertyId);
        if (existingCompanyProperty && existingCompanyProperty !== undefined) {
          return existingCompanyProperty === null || existingCompanyProperty === void 0 ? void 0 : existingCompanyProperty.details.fetchPropertyAppfolioGlCodes({
            forceUpdate: true
          });
        }
      } else {
        return getRoot(store).credentials.getAppfolioPropertiesAsync.run({}, customInProgressFetchId).then(resp => {
          if (resp !== null && resp !== void 0 && resp.isSuccessful) {
            resp.response.forEach(appfolioPropertyItem => {
              if (appfolioPropertyItem !== null && appfolioPropertyItem !== void 0 && appfolioPropertyItem.propertyLivableId) {
                const existingCompanyProperty = store.propertyDetails(appfolioPropertyItem === null || appfolioPropertyItem === void 0 ? void 0 : appfolioPropertyItem.propertyLivableId);
                if (!!existingCompanyProperty && existingCompanyProperty !== undefined) {
                  existingCompanyProperty === null || existingCompanyProperty === void 0 || existingCompanyProperty.details.setPropertyGlCodeSetup(appfolioPropertyItem);
                }
              }
            });
          }
        });
      }
    },
    setCompanyPortfoliosData(payload) {
      const portfolioParser = portfolio => {
        return {
          id: portfolio.key,
          name: portfolio.value,
          isDefault: portfolio === null || portfolio === void 0 ? void 0 : portfolio.isDefault
        };
      };
      payload.forEach(portfolioPayload => {
        const parsedPortfolio = portfolioParser(portfolioPayload);
        const existingPortfolioIndex = store.companyPortfoliosData.findIndex(i => i.id === parsedPortfolio.id);
        if (existingPortfolioIndex !== -1) {
          store.companyPortfoliosData[existingPortfolioIndex] = parsedPortfolio;
        } else {
          store.companyPortfoliosData.push(parsedPortfolio);
        }
      });
    },
    fetchCompanyPortfoliosData() {
      var _params$customUnicInP, _params$customUnicInP2;
      let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        useUnicInProgress: true,
        customUnicInProgress: []
      };
      return getRoot(store).portfolios.getExistingPortfoliosAsync.run({
        companyId: store.id
      }, params.useUnicInProgress && !(params !== null && params !== void 0 && (_params$customUnicInP = params.customUnicInProgress) !== null && _params$customUnicInP !== void 0 && _params$customUnicInP.length) ? [store.id] : !!(params !== null && params !== void 0 && (_params$customUnicInP2 = params.customUnicInProgress) !== null && _params$customUnicInP2 !== void 0 && _params$customUnicInP2.length) ? params === null || params === void 0 ? void 0 : params.customUnicInProgress : null).then(res => {
        if (res !== null && res !== void 0 && res.isSuccessful) store.setCompanyPortfoliosData(res.response);
        return res;
      });
    }
  };
}).views(store => ({
  propertyPortfolioDetails(propertyId) {
    return store.portfolios.find(portfolio => portfolio.properties.findIndex(property => property.id === propertyId) !== -1);
  },
  findReplacementPortfolioId(excludedPortfolioId, propertyId) {
    var _portfolios$find;
    const portfolios = store.portfolios.filter(portfolio => portfolio.id !== excludedPortfolioId);
    if (portfolios.length === 0) return null;
    return ((_portfolios$find = portfolios.find(portfolio => portfolio.properties.find(property => property.id === propertyId))) === null || _portfolios$find === void 0 ? void 0 : _portfolios$find.id) || null;
  },
  portfolioDetails(portfolioId) {
    return store.portfolios.find(portfolio => portfolio.id === portfolioId);
  },
  companyPortfolioDataDetails(portfolioId) {
    return store.companyPortfoliosData.find(portfolio => portfolio.id === portfolioId);
  },
  propertyDetails(propertyId) {
    var _store$portfolios$fin;
    return (_store$portfolios$fin = store.portfolios.find(portfolio => portfolio.properties.findIndex(property => property.id === propertyId) !== -1)) === null || _store$portfolios$fin === void 0 ? void 0 : _store$portfolios$fin.properties.find(i => i.id === propertyId);
  },
  selectedPropertyDetails() {
    var _store$portfolios$fin2;
    return (_store$portfolios$fin2 = store.portfolios.find(portfolio => portfolio.properties.findIndex(property => property.id === getRoot(store).homeDashboardStore.propertyId) !== -1)) === null || _store$portfolios$fin2 === void 0 ? void 0 : _store$portfolios$fin2.properties.find(i => i.id === getRoot(store).homeDashboardStore.propertyId);
  },
  getUtilityInfoById(id) {
    return store.utilitiesInfo.find(utInfo => utInfo.utilityTypeId === id || utInfo.utilityId === id);
  },
  getOldUtilityInfoById(id) {
    return store.utilitiesInfo.find(utInfo => utInfo.id === id);
  },
  get companyReimbursementMethods() {
    return store.reimbursementMethods || null;
  },
  getPropertyReimbursementMethods(propertyId) {
    return store.reimbursementMethods.find(method => method.propertyIds.includes(propertyId)) || null;
  },
  companyTeamMemberDetails(id) {
    return store.teamMembers.find(i => i.id === id);
  },
  get getAllUnicCompanyProperties() {
    var _getRoot$homeDashboar4;
    if ((_getRoot$homeDashboar4 = getRoot(store).homeDashboardStore.currentAbortController) !== null && _getRoot$homeDashboar4 !== void 0 && _getRoot$homeDashboar4.signal.aborted) return;
    return Array.from(new Map(store.portfolios.flatMap(portfolio => portfolio.properties).filter(property => property !== undefined).map(property => [property.id, property])).values());
  },
  get companyPortfoliosList() {
    var _store$companyPortfol;
    if (!((_store$companyPortfol = store.companyPortfoliosData) !== null && _store$companyPortfol !== void 0 && _store$companyPortfol.length)) {
      store.fetchCompanyPortfoliosData();
    } else {
      return store.companyPortfoliosData;
    }
  }
}));
export const companyData = CompanyData;